import { EXECUTIONER } from '../cards/attack/executioner';
import { WORLDBREAKER } from '../cards/attack/worldbreaker';
import { AEGIS } from '../cards/defense/aegis';
import { DOOMSDAY_CLOCK } from '../cards/trap/doomsday-clock';
import type { EnemyTemplate } from './template';

/** HEX-83 roster (docs/enemies.md). Legendary tier: 4×4, 5 dice, trap-aware AI.
 * Apocalypse on a timer — the trap-aware AI charges the Clock and races you to
 * its detonation, blocking with Aegis to survive its own 30-dmg bleed while
 * Worldbreaker/Executioner pressure you. End it before the Clock decides, or
 * out-survive the blast. Executioner is rotated to a 2×1 column to fill the
 * 4×4 alongside the 2×3 Worldbreaker and two 2×2 blocks. */
export const THE_HOLLOW_KING: EnemyTemplate = {
  id: 'the-hollow-king',
  name: 'The Hollow King',
  glyph: '♚', // hollow crown
  tier: 'legendary',
  hp: 53,
  loadout: [
    { card: WORLDBREAKER, origin: { row: 0, col: 0 }, rotated: false },
    { card: EXECUTIONER, origin: { row: 0, col: 3 }, rotated: true },
    { card: AEGIS, origin: { row: 2, col: 0 }, rotated: false },
    { card: DOOMSDAY_CLOCK, origin: { row: 2, col: 2 }, rotated: false },
  ],
  drops: { gold: 50 },
};
